<template>
  <div v-if="loaded" class="container">

    <!-- v2.2 -->
    <div v-if="false">
      <div class="banner">
        <div class="list">
          <div class="list_header">
            <img src="../../assets/images/base/logo_home.png" />
          </div>
          <van-swipe indicator-color="white" autoplay="6000" :show-indicators="false" :loop="true" :stop-propagation="true">
            <van-swipe-item class="vindex_banner_item" v-for="(item,key) in banner" :key="key" @click="selectSwiper(item,key)">
              <!-- <img :src="item.img" /> -->
              <div class="item" :style="'background-image: url('+item.img+');'"></div>
              <div class="vindex_banner_item_indicators">
                <span :class="[{'indicators_block_current':key==keyVlaue},'indicators_block']" v-for="(itemIcon,keyVlaue) in banner" :key="keyVlaue"></span>
              </div>
            </van-swipe-item>
          </van-swipe>
          <div class="vindex_func">
            <div class="vindex_func_item">
              <van-row type="flex" justify="space-around">
                <van-col span="6">
                  <div class="vindex_func_item_block" @click="FLToReserve('0')">

                    <img src="../../assets/images/FLVersion/swim_home.png" />
                    <div>游泳健身</div>
                  </div>
                </van-col>
                <van-col span="6">
                  <div class="vindex_func_item_block" @click="FLToReserve('1')">
                    <img src="../../assets/images/FLVersion/yoga_home.png" />
                    <div>瑜伽</div>
                  </div>
                </van-col>
                <van-col span="6">
                  <div class="vindex_func_item_block" @click="toActivate()">

                    <img src="../../assets/images/FLVersion/activation_home.png" />
                    <div>激活</div>
                  </div>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
      </div>

      <div class="fl_topseat"></div>
      <wx-open-launch-weapp id="launch-btn" username="gh_9f895bb61a7d" path="pages/fb_index/fb_index.html">
        <script type="text/wxtag-template">
          <style>
            .btn {width: 100%;background: #f8f8f8;border: none;outline: none;padding: 0;margin: 0; }
            .btniiiii{width: 100%;}
          </style>
          <button class="btn">
            <img class="btniiiii" src="http://img.unionfit.cn/fl_bv.png" />
          </button>
        </script>
      </wx-open-launch-weapp>
      <img @click="FLToLimitedActivy()" class="fl_active_img" src="../../assets/images/FLVersion/fl_la.png" />

      <!-- list -->
      <div class="vindex_list">
        <div class="vindex_list_title">
          FEATURED HOTEL
          <div>精选酒店</div>
        </div>

        <div v-for="(rec_item,rec_index) in fl_recentStadiums" @click="toSinlePage(rec_item.stadium_id)" class="vindex_list_block" :key="rec_item.stadium_id">
          <div class="vindex_list_block_img"  :style="'background-image: url('+rec_item.thumb+')'">
            <img src="../../assets/images/FLVersion/fl_index_icon.png" />
            <div>近期去过</div>
          </div>
        </div>

        <!-- <div v-for="(item,index) in list" class="vindex_list_block animated fadeInRight" :key="index" v-lazy="item" :style="'animation-delay:'+(index *0.05)+'s'" @click="toReserve(2)"> -->
        <div v-for="(item,index) in list" @click="toSinlePage(item.stadium_id)" class="vindex_list_block" :key="index">
          <!-- <img :src="item.stadium_thumb" /> -->
          <div class="vindex_list_block_img"  :style="'background-image: url('+item.stadium_thumb+')'">
            <!-- <img src="../../assets/images/FLVersion/fl_index_icon.png" /> -->
            <!-- <div>近期没去过</div> -->
            <img src="../../assets/images/FLVersion/fl_index_icon.png" />
            <div>酒店上新</div>
          </div>
          <!-- <div class="vindex_list_block_more" v-if="false">
            <label>MORE</label>
          </div> -->
        </div>
      </div>
      <!-- grid -->
      <div class="vindex_grid">
        <div class="vindex_grid_left">
          <img :src="vindex_grid_imgA" @click="toSinlePage(vindex_grid_imgA_id)" v-lazy="vindex_grid_imgA"/>
        </div>
        <div class="vindex_grid_right">
          <img @click="toSinlePage(vindex_grid_imgB_id)" class="vindex_grid_right_img1" :src="vindex_grid_imgB"  v-lazy="vindex_grid_imgB" />
          <img @click="toSinlePage(vindex_grid_imgC_id)" class="vindex_grid_right_img2" :src="vindex_grid_imgC"  v-lazy="vindex_grid_imgC" />
        </div>
        <div class="clearboth"></div>
      </div>
      <!-- band -->
      <div class="bb_index_brand">
        <div v-for="(item,index) in brand" @click="toBrand(item,index)" class="bb_index_brand_item">
          <!-- <div class="bb_index_brand_item_logo"></div> -->
          <img class="bb_index_brand_item_logo" :src="item.brand_logo" />
          <div class="bb_index_brand_item_title">{{item.brand_name}}</div>
          <div class="bb_index_brand_item_block">
            <img class="bb_index_brand_item_block_img" :src="item.brand_thumb" />
            <div class="bb_index_brand_item_block_tip">精选品牌</div>
          </div>
        </div>
      </div>
      <!-- 品牌 -->
      <div class="vindex_brand">
        <div class="vindex_brand_block">
          <div class="vindex_brand_block_title">品牌馆</div>
          <div class="vindex_brand_block_item">
            <van-row type="flex" justify="space-between">
              <van-col span="12">
                <div class="vindex_brand_block_item_cell_left">
                  <img src="../../assets/images/base/1.png"  />
                </div>
              </van-col>
              <van-col span="12">
                <div class="vindex_brand_block_item_cell_right">
                  <img src="../../assets/images/base/2.png"  />
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="12">
                <div class="vindex_brand_block_item_cell_left">
                  <img src="../../assets/images/base/3.png"  />
                </div>
              </van-col>
              <van-col span="12">
                <div class="vindex_brand_block_item_cell_right">
                  <img src="../../assets/images/base/4.png"  />
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="12">
                <div class="vindex_brand_block_item_cell_left">
                  <img src="../../assets/images/base/5.png"  />
                </div>
              </van-col>
              <van-col span="12">
                <div class="vindex_brand_block_item_cell_right">
                  <img src="../../assets/images/base/6.png"  />
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <van-divider>斐燃生活</van-divider>

      <!-- 秒杀弹框 -->
      <div v-show="bb_vindex_mask_ovmask_h" class="bb_vindex_mask_ov" @touchmove.prevent></div>
      <div v-show="bb_vindex_mask_ovmask_h" class="bb_vindex_mask_co" @touchmove.prevent>
        <div class="bb_vindex_mask_cocont">
          <img @click="toMSActivity()" class="bb_vindex_mask_cocont_a" src="../../assets/images/activity/miaosha/12312313123123.png" />
          <img @click="closeMSActivity()" class="bb_vindex_mask_cocont_b" src="../../assets/images/base/close_white.png" />
        </div>
      </div>

      <!-- 2021年第一个活动 -->
      <van-popup v-model="flv_activity_first" :close-on-click-overlay='false' :close-on-popstate='true' :style="{ width: '100%',background: 'none' }"  position="center" >
        <div class="flvf_popup">
          <img v-show="flv_activity_first_isOpen_over==0" :class="[{'animated bounceOutUp':flv_activity_first_isOpen==1},'flvf_popup_img1']" src="../../assets/images/activity/202102/envelopes1.png" />
          <img v-show="flv_activity_first_isOpen_over==0" :class="[{'animated bounceOutDown':flv_activity_first_isOpen==1},'flvf_popup_img2']" src="../../assets/images/activity/202102/envelopes2.png" />
          <img v-show="flv_activity_first_isOpen_over==0" @click="FLVOpenEnvelope()" :class="[{'animated  flipOutY':flv_activity_first_isOpen_btn==1},'flvf_popup_img3']" src="../../assets/images/activity/202101/envelopes3.png" />
          <div v-show="flv_activity_first_isOpen_over==1" @click="FLToVip()" :class="[{'animated bounceIn':flv_activity_first_isOpen_over==1},'flvf_popup_img4']">
            <img src="../../assets/images/activity/202102/envelopes41.png" />
            <div class="flvf_popup_img4_txt">
              <div class="flvf_popup_img4_txt_title">斐燃预约抵用券</div>
              <div class="flvf_popup_img4_txt_stitle">每次限用一张</div>
              <div class="flvf_popup_img4_txt_date">有效期至：{{sbxq}}</div>
            </div>
          </div>
          <img @click="FLVCloseEnvelope()" class="flvf_popup_clos" src="../../assets/images/activity/202101/close_white.png" />
        </div>
      </van-popup>
    </div>

    <!-- v2.3 -->
    <!-- 非会员 -->
    <div v-if="!viper" class="fl23_unviper">
      <div class="fl23_unviper_title">斐燃VIP会员</div>
      <div class="fl23_unviper_stitle">
        畅享五星级奢华酒店游泳/健身/瑜伽<br />
        限量发行中
      </div>
      <label @click="fl23OpenVip()" class="fl23_unviper_openvip">开通会员</label>
      <div class="fl23_unviper_swiper">
        <van-swipe :autoplay="3000" @change="fl23UnViperSwiper" :stop-propagation="true" style="width: 100%;">
          <!-- <van-swipe-item @click="fl23UnViperSwiperClickM">
            <img style="width: 100%;" src="../../assets/images/activity/202104/aa7.png" />
          </van-swipe-item> -->
          <van-swipe-item  @click="fl23UnViperSwiperClick" >
            <img style="width: 100%;" src="../../assets/images/fl20210204/fl23_1.png" />
          </van-swipe-item>
          <van-swipe-item  @click="fl23UnViperSwiperClick">
            <img style="width: 100%;" src="../../assets/images/fl20210204/fl23_2.png" />
          </van-swipe-item>
          <van-swipe-item @click="fl23UnViperSwiperClick">
            <img style="width: 100%;" src="../../assets/images/fl20210204/fl23_3.png" />
          </van-swipe-item>

          <template #indicator>
            <div class="fl23_unviper_swiper_indicator"><label>{{fl23_swiper_current+1}}/</label>3</div>
            <!--  v-show="fl23_swiper_current>0" -->
            <img @click="fl23UnViperSwiperClick" class="fl23_unviper_swiper_icon" src="../../assets/images/fl20210204/fl23_icon.png" />
          </template>

        </van-swipe>
      </div>
      <div class="fl23_unviper_enter">
        <div class="fl23_unviper_enteritem">
          <div class="fl23_unviper_enteritem_title">斐燃会员，享高端的泳健瑜伽</div>
          <div class="fl23_unviper_enteritem_stitle">
            手机提前预约&nbsp;/&nbsp;快速下场
          </div>
          <div class="fl23_unviper_enterblock">
            <div @click="FLToReserve('0')" class="fl23_unviper_enterblock_left">
              <div class="fl23_unviper_enterblock_left_ma"></div>
              <div class="fl23_unviper_enterblock_left_co">
                游泳健身
                <div>立即预约</div>
                <!-- <img src="../../assets/images/fl20210204/fl23_arr.png" /> -->
              </div>
            </div>
            <div @click="FLToReserve('1')" class="fl23_unviper_enterblock_right">
              <div class="fl23_unviper_enterblock_right_ma"></div>
              <div class="fl23_unviper_enterblock_right_co">
                瑜伽
                <div>立即预约</div>
                <!-- <img src="../../assets/images/fl20210204/fl23_arr.png" /> -->
              </div>
            </div>
            <div class="clearboth"></div>
          </div>
        </div>
      </div>
      <div class="fl23_unviper_activity">
        <img @click="FLToLimitedActivy()" src="../../assets/images/fl20210204/fl23_limite.png" />
        <img @click="toActivate()" src="../../assets/images/fl20210204/fl23_active.png" />
        <div class="clearboth"></div>
      </div>
      <div class="fl23_unviper_banner">
        <van-swipe indicator-color="white" autoplay="6000" :show-indicators="false" :loop="true" :stop-propagation="true">
          <van-swipe-item class="vindex_banner_item" v-for="(item_banner,key_banner) in banner" :key="key_banner" @click="selectSwiper(item_banner,key_banner)">
            <!-- <img :src="item.img" /> -->
            <div class="item" :style="'background-image: url('+item_banner.img+');'"></div>
            <div class="vindex_banner_item_indicators">
              <span :class="[{'indicators_block_current':key_banner==keyVlaue},'indicators_block']" v-for="(itemIcon,keyVlaue) in banner" :key="keyVlaue"></span>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- 斐燃会员 -->
    <div v-else class="fl23_viper">
      <div class="fl23_unviper_banner">
        <van-swipe indicator-color="white" autoplay="6000" :show-indicators="false" :loop="true" :stop-propagation="true">
          <van-swipe-item class="vindex_banner_item" v-for="(banneritem,bannerkey) in banner" :key="bannerkey" @click="selectSwiper(banneritem,bannerkey)">
            <div class="item" :style="'background-image: url('+banneritem.img+');'"></div>
            <div class="vindex_banner_item_indicators">
              <span :class="[{'indicators_block_current':bannerkey==keyVlaue},'indicators_block']" v-for="(itemIcon,keyVlaue) in banner" :key="keyVlaue"></span>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="fl23_unviper_enter">
        <div class="fl23_unviper_enteritem">
          <div class="fl23_unviper_enteritem_title">斐燃会员，享高端的泳健瑜伽</div>
          <div class="fl23_unviper_enteritem_stitle">
            手机提前预约&nbsp;/&nbsp;快速下场
          </div>
          <div class="fl23_unviper_enterblock">
            <div @click="FLToReserve('0')" class="fl23_unviper_enterblock_left">
              <div class="fl23_unviper_enterblock_left_ma"></div>
              <div class="fl23_unviper_enterblock_left_co">
                游泳健身
                <div>立即预约</div>
                <!-- <img src="../../assets/images/fl20210204/fl23_arr.png" /> -->
              </div>
            </div>
            <div @click="FLToReserve('1')" class="fl23_unviper_enterblock_right">
              <div class="fl23_unviper_enterblock_right_ma"></div>
              <div class="fl23_unviper_enterblock_right_co">
                瑜伽
                <div>立即预约</div>
                <!-- <img src="../../assets/images/fl20210204/fl23_arr.png" /> -->
              </div>
            </div>
            <div class="clearboth"></div>
          </div>
        </div>
      </div>
      <div class="fl23_unviper_activity">
        <img @click="FLToLimitedActivy()" src="../../assets/images/fl20210204/fl23_limite.png" />
        <img @click="toActivate()" src="../../assets/images/fl20210204/fl23_active.png" />
        <div class="clearboth"></div>
      </div>
    </div>
    <!-- 优质精选 -->
    <div class="fl23_list">
      <div class="fl23_list_title">
        <!-- 优质精选 -->
        <img class="fl23_list_title_hotol" src="../../assets/images/fl20210204/vip_index_hotal.png" />
      </div>

      <div v-for="(itemrecent,indexrecent) in fl_recentStadiums" :key="indexrecent+'re'" @click="toSinlePage(itemrecent.stadium_id)" :style="'background-image: url('+itemrecent.thumb+');'" class="fl23_list_item fl23_list_item_re">
        <div class="fl23_list_item_re_img">
          近期去过&nbsp;
          <!-- <img src="../../assets/images/FLVersion/fl_index_icon.png" /> -->
        </div>

      </div>
      <div v-for="(item,index) in list" :key="index" @click="toSinlePage(item.stadium_id)" :style="'background-image: url('+item.stadium_thumb+');'" class="fl23_list_item"></div>
    </div>
    <!-- 品牌酒店 -->
    <div class="fl23_list">
      <div class="fl23_list_title">
        <!-- 品牌酒店 -->
        <img class="fl23_list_title_brand" src="../../assets/images/fl20210204/vip_index_brand.png" />
      </div>
      <div v-for="(item_brand,index_brand) in brand" :key="index_brand" @click="toBrand(item_brand,index_brand)" :style="'background-image: url('+item_brand.brand_thumb+');'" class="fl23_brand_item"></div>

    </div>
    <div v-show="vip_regiest" :class="[{'fl23_list_loginH':longPhone},'fl23_list_login']">
      <div class="fl23_list_logindiv">

        <img class="fl23_list_logindiv_icon" src="../../assets/images/fl20210204/flindexregiest.png" />
        <div class="fl23_list_logindiv_txt">
          注册登录立即享受高端酒店<br />
          游泳、健身、瑜伽服务
        </div>
        <div @click="closeregiestlogin()" class="fl23_list_logindiv_btn">立即登录</div>
        <div @click="closeregiest()" class="fl23_list_logindiv_close"></div>
        <div class="clearboth"></div>
      </div>
    </div>
    <!-- <van-divider>斐燃生活</van-divider> -->

    <van-popup v-model="flv_activity_first" :close-on-click-overlay='false' :close-on-popstate='true' :style="{ width: '100%',background: 'none' }"  position="center" >
      <div class="flvf_popup">
        <img @click="toacds()" class="flvf_popup_img304" src="http://img.unionfit.cn/qingming_a5.png" />

        <img @click="FLVCloseEnvelope()" class="flvf_popup_clos" src="../../assets/images/activity/202101/close_white.png" />
      </div>
    </van-popup>

    <!-- <div v-show="sq_is_show" @click="qushenquan()" class="vip_customac">
      斐燃<br />神券
    </div> -->

  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        vindex_grid_imgA:'',
        vindex_grid_imgA_id:'',
        vindex_grid_imgB:'',
        vindex_grid_imgB_id:'',
        vindex_grid_imgC:'',
        vindex_grid_imgC_id:'',
        bb_vindex_mask_ovmask_h:false,//秒杀弹框
        fl_recentStadiums:[],//近期去过酒店
        // 2021活动1
        flv_activity_first:false,
        flv_activity_first_isOpen:0,//0:未开红包 1已开红包
        flv_activity_first_isOpen_over:0,//0:开红包未结束  1:开红包结束
        flv_activity_first_isOpen_btn:0,//与 flv_activity_first_isOpen 同步，比小程序提前执行
        fl_getcouponSuccess:0,
        sbxq:'',//傻逼需求

        /**
         v2.3
         */
        banner:[{img:require('../../assets/images/base/banner_init.png'),url:'',type:1}],
        brand:[],
        list:[],
        fl23_swiper_current:0,
        viper:false,
        loaded:false,
        longPhone:false,
        vip_regiest:false,

        sq_is_show:false
      }
    },
    created() {


      // 近期预约酒店
      this.getRecentStadiums()//flRecentStadiums


      // 2.3
      // 首页酒店列表
      this.getIndexStadiums()
      // 首页品牌
      this.getBrands()
      // 首页banner
      this.getBanners()

      this.FLFirstActivity()

      this.shenquan()
    },
    activated() {
      sessionStorage.removeItem('fullpage')
      if(sessionStorage.getItem('index_scroll_top')=='yes'){
        sessionStorage.removeItem('index_scroll_top')
        window.scrollTo(0, 0)
      }
      // 分享模块，每次进入此页面都执行，
      this.getJsAuth()
      // 修改标题
      document.title = '百动斐燃——畅享五星级奢华酒店游泳/健身';
      // // 跳转小程序准备
      // var btn = document.getElementById('launch-btn');
      // btn.addEventListener('launch', function (e) {
      //   console.log('success');
      // });
      // btn.addEventListener('error', function (e) {
      //   console.log('fail', e.detail);
      // });
      // 活动弹窗
      // this.FLFirstActivity()

      /**
       * v2.3
       */
      // 判断是否存在有效会员卡
      this.getUserCard()
      this.phoneSystem()
    },
    methods:{
      shenquan(){
        if(new Date().getTime() >= new Date('2021/04/09').getTime()){
          // console.log('活动已结束')
          this.sq_is_show=false
          // return
        }else{
          // console.log('活动进行中')
          this.sq_is_show=true
          // return
        }
      },
      qushenquan(){
        this.$router.push({
          name:'acfour'
        })
      },
      toDisCountList(){
        this.$router.push({
          name:'discountlist'
        })
      },
      toActivate(){
        this.$router.push({
          name:'activate_single'
        })
      },
      toReserve(){
        this.$router.push({
          name:'reserve'
        })
      },
      toSinlePage(item){
        // console.log(item)
        this.$router.push({
          name:'resdetail',
          params:{
            stadium_id:item
          }
        })
      },
      toBrand(item,index){
        // console.log(item)
        // console.log(index)
        // return
        this.$router.push({
          name:'brand',
          params:{
            stadium_brand_id:item.stadium_brand_id
          }
        })
      },
      // 秒杀每日弹窗暂时取消
      MSActivity(){
        return
        // 秒杀每日弹窗暂时取消
        var $this = this
        if ($this.$cookies.get('mstips') === 'yes') {
          // // console.log($this.$cookies.get('tips'))
        } else {
          var expires = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0));
          this.$cookies.set('mstips', 'yes', expires)
          this.bb_vindex_mask_ovmask_h=true
        }
      },
      // 前往秒杀活动
      toMSActivity(){
        this.bb_vindex_mask_ovmask_h=false
        this.$router.push({
          name:'hotsell'
        })
        // console.log('前往秒杀活动')
      },
      // 关闭秒杀活动
      closeMSActivity(){
        this.bb_vindex_mask_ovmask_h=false
      },
      // 点击swiper
      selectSwiper(item,index){
        // 2.3
        if(item.url.indexOf('hotsell')==0){
          window.location.href=item.url
        }else{
          console.log(item.url.indexOf('resdetail'))
          if(item.url.indexOf('resdetail')==0){
            console.log((item.url).split('resdetail-')[1])
            this.$router.push({
              name:'resdetail',
              params:{
                stadium_id:(item.url).split('resdetail-')[1]
              }
            })
            // .split('&code')[0]
          }else{
            this.$router.push({
              name:item.url
            })
          }
        }


        // // 2.2
        // if(item.url.indexOf('hotsell')==0){
        //   window.location.href=item.url
        // }else{
        //   this.$router.push({
        //     name:item.url
        //   })
        // }
      },
      // 分享模块\
      getJsAuth() {
        // getJsAuth
        let that = this;
        // that.shareApp()
        // return
        var param = {
          url: encodeURIComponent(window.location.href)//location.href.split('#')[0]//encodeURIComponent(window.location.href)
        }
        var qs = require('qs');
        let url = this.api.userApi.getJsAuth
        this.axios.post(url, qs.stringify(param), )
        .then((res) => {
          // // console.log(res)
          wx.config({
            debug: false,
            appId: res.data.appid, // 必填，公众号的唯一标识
            timestamp: res.data.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.data.noncestr, // 必填，生成签名的随机串
            signature: res.data.signature,
            jsApiList: [
              'getLocation',
              'updateAppMessageShareData', //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
              'updateTimelineShareData', //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
              'onMenuShareTimeline', //分享到朋友圈 老接口
              'onMenuShareAppMessage', //分享给盆友 老接口
            ],
            openTagList: ['wx-open-launch-weapp']
          });
          wx.ready(function() {
            that.shareApp()
          });
        }).catch((error) => {
          console.warn(error)
          that.$toast(error);
        })
      },
      shareApp(){
        let that = this;
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // const baseurl = encodeURI((window.location.href).split('.cn')[0])+'.cn'//"http://test.official.unionfit.cn"; //本地测试地址
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateAppMessageShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateAppMessageShareData')
            }
          });
          wx.updateTimelineShareData({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.updateTimelineShareData')
              console.log(res)
            },
            fail(){
              // alert('fail wx.updateTimelineShareData')
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareAppMessage')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareAppMessage')
            }
          });
          wx.onMenuShareTimeline({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              console.log('斐燃生活分享')
              // alert('wx.onMenuShareTimeline')
              console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareTimeline')
            }
          });
        }
      },

      // ---v2.2---
      // 前往秒杀活动
      FLToLimitedActivy(){
        this.$router.push({
          name:'hotsell'
        })
      },
      // 前往酒店列表
      FLToReserve(item){
        sessionStorage.setItem('listRadio',item)
        this.$router.push({
          name:'reserve'
        })
      },
      // 近期前往酒店
      getRecentStadiums(){
        var $this=this;
        if(localStorage.getItem('token')){
          var param={
            token: localStorage.getItem("token"),
          }
          var qs = require('qs');
          let url = this.api.userApi.flRecentStadiums
          this.axios.post(url,qs.stringify(param),)
          .then((res) => {
            console.log(res)
            if(res.code==0){
              // console.log(res.data)
              if(res.data && res.data.length>0){
                $this.fl_recentStadiums=res.data
              }else{
                $this.fl_recentStadiums=[]
              }
            }else{
              // $this.$toast(res.msg);
            }
          }).catch((error) => {
            console.warn(error)
            $this.$toast(res.msg);
          })
        }
      },
      // 判断是否存在有效会员卡
      getUserCard(){
        var $this=this
        if(localStorage.getItem('token')){
          $this.vip_regiest=false
          if($this.$store.state.array_mycard.length==0){
            let param = {
              token: localStorage.getItem("token")
            }
            var qs = require('qs');
            let url = this.api.userApi.flUserCardsList
            this.axios.post(url, qs.stringify(param), )
            .then((result) => {
              // console.log(result)
              if (result.data) {
                if(result.data.length>0){
                  var arrsas=[]
                  for (var i = 0; i < result.data.length; i++) {
                    if(result.data[i].vip_tag=="A1"||result.data[i].vip_tag=="A2"||result.data[i].vip_tag=="B1"||result.data[i].vip_tag=="B2"||result.data[i].vip_tag=="C1"||result.data[i].vip_tag=="C2"){
                      arrsas.push(result.data[i])
                    }
                  }
                  if(arrsas.length>0){
                    $this.viper=true
                    $this.loaded=true
                    $this.$store.commit('updataMycard',result.data)
                  }else{
                    $this.viper=false
                    $this.loaded=true
                  }



                }else{
                  $this.viper=false
                  $this.loaded=true
                }
              } else {
                $this.viper=false
                $this.loaded=true
              }
            }).catch((error) => {
              console.warn(error)
            })
          }else{
            var arrsas=[]
            var resultdata=$this.$store.state.array_mycard
            for (var i = 0; i < resultdata.length; i++) {
              if(resultdata[i].vip_tag=="A1"||resultdata[i].vip_tag=="A2"||resultdata[i].vip_tag=="B1"||resultdata[i].vip_tag=="B2"||resultdata[i].vip_tag=="C1"||resultdata[i].vip_tag=="C2"){
                arrsas.push(resultdata[i])
              }
            }
            if(arrsas.length>0){
              $this.viper=true
              $this.loaded=true

            }else{
              $this.viper=false
              $this.loaded=true
            }




            // $this.viper=true
            // $this.loaded=true
          }
        }else{
          $this.viper=false
          $this.vip_regiest=true
          $this.loaded=true
        }


      },

      /**
       * 2021第一次活动
       *  新用户可以看到弹框
       *  无卡用户可以看到弹框
       */
      // 判断是否显示
      FLFirstActivity(){
        return
        // console.log(new Date().getFullYear())
        var sbxqy=new Date().getFullYear()
        // console.log(new Date().getMonth()+2)
        var sbxqym=new Date().getMonth()+2
        // console.log(new Date().getDate()-1)
        var sbxqyd=new Date().getDate()-1
        this.sbxq=sbxqy+'年'+sbxqym+'月'+sbxqyd+'日'
        // return
        if(new Date().getTime() >= new Date('2021/04/09').getTime()){
          console.log('活动已结束')
          return
        }
        console.log(localStorage.getItem('ac_20210401'))
        if(localStorage.getItem('ac_20210401')=='yes'){
          console.log('活动已参与')
          return
        }else{
          this.flv_activity_first=true
          console.log('开始活动')
        }

        return

        // this.flv_activity_first=true

        // // 第二次活动
        // // console.log('活动进行中:'+new Date().getDate())
        // console.log(this.$cookies.get('ac_20210205'))
        // if (this.$cookies.get('ac_20210205') == 'yes') {
        //   // console.log('今天已经领过')
        // } else {
        //   var expires = new Date(new Date(new Date().getTime() + 24 * 60 * 60 * 1000).setHours(0, 0, 0, 0));
        //   if(localStorage.getItem('token')){
        //     this.$cookies.set('ac_20210205', 'yes', expires)
        //     this.flv_activity_first=true
        //     this.FLVGetCoupon()
        //   }
        // }
        // return
        // // 第一次活动
        // if(localStorage.getItem('ac_20210113')){
        //   this.flv_activity_first=false
        //   return
        // }
        // if(localStorage.getItem('token')){
        //   var $this = this
        //   let param = {
        //     token: localStorage.getItem("token")
        //   }
        //   var qs = require('qs');
        //   let url = this.api.userApi.flUserCardsList
        //   this.axios.post(url, qs.stringify(param), )
        //   .then((result) => {
        //     if (result.code==0) {
        //       // console.log(result)
        //       // result.data=[]
        //       if(result.data&&result.data.length>0){
        //         // console.log('有会员卡')
        //         var isOld=0
        //         for (var i = 0; i < result.data.length; i++) {
        //           if(result.data[i].vip_tag=='A1'||result.data[i].vip_tag=='A2'||result.data[i].vip_tag=='B1'||result.data[i].vip_tag=='B2'||result.data[i].vip_tag=='C1'||result.data[i].vip_tag=='C2'){
        //             isOld=1
        //             break
        //           }
        //         }
        //         if(isOld==0){
        //           if(!localStorage.getItem('ac_20210113')){
        //             $this.flv_activity_first=true
        //             localStorage.setItem('ac_20210113','yes')
        //             $this.FLVGetCoupon()
        //           }
        //         }
        //       }else{
        //         // console.log('无会员卡')
        //         if(!localStorage.getItem('ac_20210113')){
        //           $this.flv_activity_first=true
        //           localStorage.setItem('ac_20210113','yes')
        //           this.FLVGetCoupon()
        //         }
        //       }
        //       // console.log($this.flswiper)
        //     } else {
        //       // $this.$toast(result.msg)
        //     }
        //   }).catch((error) => {
        //     // console.warn(error)
        //   })
        // }else{
        //   // console.warn('no token')
        //   if(!localStorage.getItem('ac_20210113')){
        //     this.flv_activity_first=true
        //   }
        // }
      },
      // 触发领卡操作
      FLVGetCoupon(){
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.flUserInAction
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          if (result.code==0) {
            // console.log(result)
            // $this.$toast('优惠券领取成功')
            $this.fl_getcouponSuccess=1
          } else {
            // $this.$toast(result.msg)
          }
        }).catch((error) => {
          // console.warn(error)
        })
      },
      // 开红包
      FLVOpenEnvelope(){
        var $this=this
        if(localStorage.getItem('token')){
          if(this.fl_getcouponSuccess==1){
            setTimeout(function(){
              $this.$toast('优惠券领取成功')
            },1000)
          }

          this.flv_activity_first_isOpen_btn=1
          setTimeout(function(){
            $this.flv_activity_first_isOpen=1
          },500)
          setTimeout(function(){
            $this.flv_activity_first_isOpen_over=1
          },1000)
        }else{
          // this.flv_activity_first=false
          setTimeout(function(){
            $this.$router.push({
              name:'login'
            })
          },300)

        }
      },
      // 关闭弹框
      FLVCloseEnvelope(){
        this.flv_activity_first=false
        return
        if(this.flv_activity_first_isOpen_over==1){
          this.flv_activity_first=false
        }
      },
      toacds(){
        this.flv_activity_first=false
        this.$router.push({
          name:'acfour'
        })
      },
      // 前往 vip
      FLToVip(){
        var $this=this
        this.flv_activity_first=false
        // console.log(this.flv_activity_first)
        setTimeout(function(){
          $this.$router.push({
            name:'reserve'
          })
        },300)
      },


      /**
       * v2.3
       */
      phoneSystem(){
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        // console.log(screen)

        if(isIOS){
          if(screen.height > 800){
            this.longPhone=true//ios 长屏
          }else{
            this.longPhone=false//ios 短屏
          }
        }else{
          this.longPhone=false//安卓端
        }

      },
      getIndexStadiums(){
        var $this=this;
        var param={city:localStorage.getItem('city')}
        var qs = require('qs');
        let url = this.api.userApi.getIndexStadiums
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // console.log(res)
          if(res.code==0){
            $this.list = res.data.stadium_list
            // $this.vindex_grid_imgA = res.data.stadium_third.INDEX_THIRD_A.stadium_thumb
            // $this.vindex_grid_imgA_id=res.data.stadium_third.INDEX_THIRD_A.stadium_id
            // $this.vindex_grid_imgB = res.data.stadium_third.INDEX_THIRD_B.stadium_thumb
            // $this.vindex_grid_imgB_id=res.data.stadium_third.INDEX_THIRD_B.stadium_id
            // $this.vindex_grid_imgC = res.data.stadium_third.INDEX_THIRD_C.stadium_thumb
            // $this.vindex_grid_imgC_id=res.data.stadium_third.INDEX_THIRD_C.stadium_id
          }else{
            $this.$toast(res.msg);
          }
        }).catch((error) => {
          console.warn(error)
          $this.$toast(res.msg);
        })
      },
      getBrands(){
        var $this=this;
        var param={city:localStorage.getItem('city')}
        var qs = require('qs');
        let url = this.api.userApi.getBrands
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          // console.log(res)
          if(res.code==0){
            $this.brand=res.data
          }else{
            $this.$toast(res.msg);
          }
        }).catch((error) => {
          console.warn(error)
          $this.$toast(res.msg);
        })
      },
      fl23UnViperSwiper(index){
        this.fl23_swiper_current = index;
      },
      fl23UnViperSwiperClick(event){

        console.log('再次展开引导模块')
        // localStorage.removeItem('fl_pilotRecommend')
        // this.$router.go(0)
        // this.$router.push({
        //   name:'index'
        // })
        // 传值给app.vue
        this.$emit('showGuidAg')
      },
      fl23UnViperSwiperClickM(){
        console.log('斐燃活动')
        this.$router.push({
          name:'acfour'
        })
      },
      getBanners(){
        var $this=this;
        var param={city:localStorage.getItem('city')}
        var qs = require('qs');
        let url = this.api.userApi.getBanners
        this.axios.post(url,qs.stringify(param),)
        .then((res) => {
          console.log(res)
          if(res.code==0){
            if(res.data.length>0){
              $this.banner=res.data
            }

          }else{
            $this.$toast(res.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast(res.msg);
        })
      },
      fl23OpenVip(){
        this.$router.push({
          name:'vip'
        })
      },
      closeregiest(){
        this.vip_regiest=false
      },
      closeregiestlogin(){
        this.$router.push({
          name:'login'
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  // ---v2.1---
  .banner{
    width: 100%;
    position: relative;
    height: 747*@vm_base;
    .list{
      width: 100%;
      .list_header{
        width: 100%;
        height: 80*@vm_base;
        background:rgba(0,0,0,0.2);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        img{
          height: 50*@vm_base;
          margin-top: 15*@vm_base;
          margin-left: 32*@vm_base;
        }
      }
      .vindex_banner_item{
        position: relative;
        .item{
          width: 100%;
          height: 563*@vm_base;
          background-size: auto 563*@vm_base;
          background-position: center;
          background-repeat: no-repeat;
        }
        .vindex_banner_item_indicators{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          margin-bottom: 60*@vm_base;
          z-index: 3;
          text-align: center;
          .indicators_block{
            display: inline-block;
            width:10*@vm_base;
            height:10*@vm_base;
            background:rgba(255,255,255,1);
            border-radius:5*@vm_base;
            opacity:0.39;
            margin: 0 3*@vm_base;
          }
          .indicators_block_current{
            width:16*@vm_base;
            background:rgba(255,255,255,1);
            opacity:1;
            border-radius:4*@vm_base;
          }
        }
      }
      .vindex_func{
        width: 100%;
        padding: 0 32*@vm_base;
        position: absolute;
        bottom: 0;
        margin-top: -60*@vm_base;
        .vindex_func_item{
          padding:42*@vm_base 0 36*@vm_base 0;
          background:rgba(255,255,255,1);
          box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
          border-radius:12*@vm_base;
          .vindex_func_item_block{
            width: 100%;
            img{
              margin: 0 auto;
              width: 104*@vm_base;
              height: 104*@vm_base;
            }
            div{
              width: 100%;
              text-align: center;
              font-weight:400;
              color:rgba(51,51,51,1);
              font-size: 28*@vm_base;
              line-height: 1;
              margin-top: 18*@vm_base;
            }
          }
        }
      }
    }
  }
  .bb_index_brand{
    width: 100%;
    padding: 0*@vm_base 32*@vm_base 0*@vm_base 32*@vm_base;
    .bb_index_brand_item{
      width:100%;
      background:rgba(255,255,255,1);
      box-shadow:0px 4*@vm_base 20*@vm_base 0px rgba(238,238,238,1);
      border-radius:12*@vm_base;
      padding: 40*@vm_base 32*@vm_base 32*@vm_base 32*@vm_base;
      margin-bottom: 80*@vm_base;
      .bb_index_brand_item_logo{
        height: 50*@vm_base;
        margin: 0 auto;
      }
      .bb_index_brand_item_title{
        width: 100%;
        text-align: center;
        height: 44*@vm_base;
        line-height: 44*@vm_base;
        color: #000000;
        font-weight: 500;
        font-size: 32*@vm_base;
        letter-spacing:6px;
      }
      .bb_index_brand_item_block{
        position: relative;
        margin-top: 22*@vm_base;
        .bb_index_brand_item_block_img{
          width: 100%;
          border-radius: 12*@vm_base;
        }
        .bb_index_brand_item_block_tip{
          width: 144*@vm_base;
          height: 60*@vm_base;
          line-height: 60*@vm_base;
          text-align: center;
          background:rgba(40,40,40,1);
          font-size:28*@vm_base;
          font-weight:400;
          color:rgba(255,255,255,1);
          position: absolute;
          top: 0;
          left: 0;
          margin-top: -36*@vm_base;
          margin-left: -32*@vm_base;
        }
      }
    }

  }
  .vindex_list_title{
    height:52*@vm_base;
    font-size:52*@vm_base;
    font-weight:900;
    color:rgba(240,240,240,1);
    line-height:52*@vm_base;
    width: 100%;
    text-align: center;
    margin-bottom: 40*@vm_base;
    margin-top: 20*@vm_base;
    position: relative;
    div{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      text-align: center;

      height:36*@vm_base;
      font-size:36*@vm_base;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:36*@vm_base;
    }
  }
  .vindex_list{
    width: 100%;
    margin-top: 80*@vm_base;
    padding: 0 32*@vm_base;
    .vindex_list_block{
      margin-bottom: 80*@vm_base;
      // border: 1px solid red;
      // overflow: hidden;
      // height: ;

      .vindex_list_block_img{
        border-radius:12*@vm_base;
        height: 428*@vm_base;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: auto 100%;
        // border: 1px solid red;
        position: relative;
        img{
          position: absolute;
          top: 0;
          left: 0;
          width: 160*@vm_base;
          margin-top: -10*@vm_base;
          z-index: 1;
        }
        div{
          position: absolute;
          top: 0;
          left: 0;
          width: 150*@vm_base;
          text-align: center;
          z-index: 2;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 1.375;
          // float: left;
          margin-top: -10*@vm_base;
          letter-spacing: 1px;
          padding: 19*@vm_base 0;
        }
      }
      // img{
      //   border-radius:12*@vm_base;
      // }
      .vindex_list_block_more{
        text-align: right;
        label{
          margin-top: 30*@vm_base;
          width: 144*@vm_base;
          line-height: 60*@vm_base;
          font-size: 28*@vm_base;
          text-align: center;
          display: inline-block;
          border-radius:6*@vm_base;
          border:1px solid rgba(102,102,102,1);
          font-weight:400;
          color:rgba(102,102,102,1);
        }
      }
    }
  }
  .vindex_grid{
    width: 100%;
    padding: 0 32*@vm_base;
    margin-bottom: 80*@vm_base;
    .vindex_grid_left{
      width: calc(34.8% - 10*@vm_base);
      float: left;
      border-radius:12*@vm_base 0px 0px 12*@vm_base;
      height: 550*@vm_base;
      overflow: hidden;
      position: relative;
      img{
        height: 550*@vm_base;
        margin: 0 auto;
        position: absolute;
        // transform: translateX(-50% + 17.4% - 5*@vm_base);
      }
    }
    .vindex_grid_right{
      width: calc(65.2% - 10*@vm_base);
      float: right;
      img{
        width: 100%;
        height: 265*@vm_base;
      }
      .vindex_grid_right_img1{
        margin-bottom: 20*@vm_base;
        border-radius:0px 12*@vm_base 12*@vm_base 0px;
      }
      .vindex_grid_right_img2{
        border-radius:0px 12*@vm_base 12*@vm_base 0px;
      }
    }
  }
  .vindex_brand{
    width: 100%;
    padding: 0 32*@vm_base;
    // margin-bottom: 80*@vm_base;
    .vindex_brand_block{
      padding:20*@vm_base 32*@vm_base;
      background:rgba(255,255,255,1);
      box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
      border-radius:12*@vm_base;
      .vindex_brand_block_title{
        width:100%;
        font-size:36*@vm_base;
        font-weight:600;
        height: 116*@vm_base;
        line-height: 116*@vm_base;
        color:rgba(40,40,40,1);
      }
      .vindex_brand_block_item{
        margin-bottom: 26*@vm_base;
        .vindex_brand_block_item_cell_left{
          width: calc(100% - 11*@vm_base);
          text-align: left;
          margin-bottom: 22*@vm_base;
          img{
            width: 100%;
            border-radius: 12*@vm_base;
          }
        }
        .vindex_brand_block_item_cell_right{
          width: calc(100% - 11*@vm_base);
          margin-bottom: 22*@vm_base;
          img{
            width: 100%;
            margin-left: 11*@vm_base;
            border-radius: 12*@vm_base;
          }
        }
      }
    }
  }
  // 秒杀弹框
  .bb_vindex_mask_ov{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.7);
  }
  .bb_vindex_mask_co{
    position: fixed;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .bb_vindex_mask_cocont{
      width: 80%;
      .bb_vindex_mask_cocont_a{
        width: 100%;
        border-radius: 12*@vm_base;
      }
      .bb_vindex_mask_cocont_b{
        width: 64*@vm_base;
        margin: 0 auto;
        margin-top: 64*@vm_base;
      }
    }
  }
  // ---v2.2---
  .fl_active_img{
    width: 100%;
    margin-top: 40*@vm_base;
    // height: 180*@vm_base;
  }
  .fl_topseat{
    height: 50*@vm_base;
  }
  // 2021-第一个活动
  .flvf_popup{
    width: 100%;
    position: relative;
    .flvf_popup_img1{
      width: 60%;
      margin-left: 20%;
    }
    .flvf_popup_img2{
      width: 66.15%;
      margin-left:15.27%;
      margin-top: -60*@vm_base;
    }
    .flvf_popup_img3{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 150*@vm_base;
      height: 150*@vm_base;
      margin-left: calc(50% - 75*@vm_base);
      margin-top: 320*@vm_base;
    }
    .flvf_popup_img304{
      width: 80vw;
      margin-left: 10%;
      // margin-top: 320*@vm_base;
    }
    .flvf_popup_img4{
      width: 78.6%;
      margin-left: 10.7%;
      position: relative;
      img{
        width: 100%;
      }
      .flvf_popup_img4_txt{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 285*@vm_base 0 0 250*@vm_base;
        .flvf_popup_img4_txt_title{
          width: 100%;
          font-size: 28*@vm_base;
          font-weight: 500;
          color: #333333;
          line-height: 1;
          white-space: nowrap;
          font-weight: bold;
        }
        .flvf_popup_img4_txt_stitle{
          width: 100%;
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #666666;
          line-height: 1;
          margin-top: 16*@vm_base;
          margin-bottom: 10*@vm_base;
          white-space: nowrap;
        }
        .flvf_popup_img4_txt_date{
          width: 100%;
          font-size: 22*@vm_base;
          font-weight: 400;
          color: #666666;
          line-height: 1;
          white-space: nowrap;
        }
      }
      // img{
      //   width: 100%;
      // }
      // .flvf_popup_img4_btn{
      //   position: absolute;
      //   bottom: 0;
      //   left: 0;
      //   width: 526*@vm_base;
      //   height: 80*@vm_base;
      //   background: linear-gradient(136deg, #FBF0CC 0%, #DC8659 100%);
      //   border-radius: 12*@vm_base;
      //   font-size: 32*@vm_base;
      //   font-weight: 500;
      //   color: #C93A1F;
      //   margin-left: calc(50% - 263*@vm_base);
      //   margin-bottom: 44*@vm_base;
      // }
      // button:before {
      //     display: block;
      //     background: rgba(255, 255, 255, 0.5);
      //     width: 0px;
      //     height: 100%;
      //     position: absolute;
      //     content: '';
      //     left: 0*@vm_base;
      //     top: 0;
      //     -webkit-animation: glint 1.6s;
      //     animation: glint 4.6s;
      //     opacity: 0;
      //     -webkit-filter: blur(30px);
      //     filter: blur(30px);
      //     -webkit-transform: translateX(-0px) skewX(-15deg);
      //     -ms-transform: translateX(-0px) skewX(-15deg);
      //     transform: translateX(-0px) skewX(-15deg);
      //     opacity: 0;
      //     border: 1px solid red;
      // }
      // button:after {
      //     display: block;
      //     background: rgba(255, 255, 255, 0.2);
      //     width: 30px;
      //     height: 100%;
      //     position: absolute;
      //     content: '';
      //     left: -90*@vm_base;
      //     top: 0;
      //     -webkit-animation: glintier 1s;
      //     animation: glintier 4.6s infinite;
      //     opacity: 0.6;
      //     -webkit-filter: blur(5px);
      //     filter: blur(5px);
      //     -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //     -ms-transform: translateX(526*@vm_base) skewX(-15deg);
      //     transform: translateX(526*@vm_base) skewX(-15deg);
      //     opacity: 0.6;
      // }
      // @-webkit-keyframes glint {
      //     0% {
      //         -webkit-transform: translateX(-50px) skewX(-15deg);
      //         transform: translateX(-50px) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
      // @keyframes glint {
      //     0% {
      //         -webkit-transform: translateX(-50px) skewX(-15deg);
      //         transform: translateX(-50px) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
      // @-webkit-keyframes glintier {
      //     0% {
      //         -webkit-transform: translateX(-526*@vm_base) skewX(-15deg);
      //         transform: translateX(-526*@vm_base) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
      // @keyframes glintier {
      //     0% {
      //         -webkit-transform: translateX(-526*@vm_base) skewX(-15deg);
      //         transform: translateX(-526*@vm_base) skewX(-15deg);
      //         opacity: 0;
      //     }
      //     100% {
      //         -webkit-transform: translateX(526*@vm_base) skewX(-15deg);
      //         transform: translateX(526*@vm_base) skewX(-15deg);
      //         opacity: 0.6;
      //     }
      // }
    }
    .flvf_popup_clos{
      width: 48*@vm_base;
      margin: 40*@vm_base auto 0 auto;
    }
  }

  /**
   * v2.3
   */
  .container{
    background: #f2f1f0;
    position: relative;
  }
  .fl23_unviper{
    width: 100%;
    padding: 64*@vm_base 40*@vm_base 0 40*@vm_base;
    background-image: url(../../assets/images/fl20210204/fl23_bg.png);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: 100% auto;
    .fl23_unviper_title{
      width: 100%;
      font-size: 60*@vm_base;
      font-weight: 500;
      color: #FFFBF4;
      padding: 0 20*@vm_base;
    }
    .fl23_unviper_stitle{
      width: 100%;
      font-size: 28*@vm_base;
      font-weight: 400;
      color: #D8CDBB;
      margin-top: 12*@vm_base;
      padding: 0 20*@vm_base;
    }
    .fl23_unviper_openvip{
      display: inline-block;
      font-size: 24*@vm_base;
      padding: 13*@vm_base 35*@vm_base;
      font-weight: 500;
      color: #F2CE88;
      letter-spacing: 1px;
      border: 2*@vm_base solid rgba(242, 206, 136, 1);
      // border-image: linear-gradient(225deg, rgba(242, 206, 136, 1), rgba(206, 167, 119, 1)) 2 2;
      margin-top: 30*@vm_base;
      margin-bottom: 64*@vm_base;
      margin-left: 20*@vm_base;
    }
    .fl23_unviper_swiper{
      width: 100%;
      .fl23_unviper_swiper_indicator{
        position: absolute;
        top: 0;
        right: 0;
        padding: 2*@vm_base 17*@vm_base;
        background: rgba(0, 0, 0, 0.25);
        font-size: 16*@vm_base;
        color: #E4E4E4;
        label{
          color: #FFFFFF;
          font-size: 20*@vm_base;
        }
      }
      .fl23_unviper_swiper_icon{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 200*@vm_base;
      }
    }
    .fl23_unviper_enter{
      width: 100%;
      height: 454*@vm_base;
      margin-top: 60*@vm_base;
      .fl23_unviper_enteritem{
        width: 100%;
        height: 380*@vm_base;
        background: #FFFFFF;
        border-radius: 4*@vm_base;
        box-shadow: 0 6*@vm_base 10*@vm_base 0 rgba(0, 0, 0, 0.2);
        .fl23_unviper_enteritem_title{
          width: 100%;
          font-size: 40*@vm_base;
          font-weight: 700;
          color: #333333;
          padding: 60*@vm_base 40*@vm_base 0 40*@vm_base;
        }
        .fl23_unviper_enteritem_stitle{
          width: 100%;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: #888888;
          padding: 20*@vm_base 40*@vm_base 40*@vm_base 40*@vm_base;
        }
        .fl23_unviper_enterblock{
          padding: 0 40*@vm_base;
          width: 100%;
          .fl23_unviper_enterblock_left{
            width: 370*@vm_base;
            height: 250*@vm_base;
            background-image: url(../../assets/images/fl20210204/fl23_swim.png);
            background-position: center;
            background-size: auto 100%;
            background-repeat: no-repeat;
            float: left;
            border-radius: 4*@vm_base;
            position: relative;
            .fl23_unviper_enterblock_left_ma{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              width: 100%;
              height: 250*@vm_base;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
              border-radius: 4*@vm_base;
              opacity: 0.5;
            }
            .fl23_unviper_enterblock_left_co{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 2;
              margin-bottom: 15*@vm_base;
              margin-left: 30*@vm_base;
              font-size: 30*@vm_base;
              font-weight: 600;
              color: #FFFFFF;
              div{
                width: 136*@vm_base;
                text-align: center;
                border: 2*@vm_base solid;
                border-image: linear-gradient(225deg, rgba(242, 206, 136, 1), rgba(206, 167, 119, 1)) 2 2;
                font-size: 20*@vm_base;
                font-weight: 500;
                color: #F2CE88;
                padding: 8*@vm_base;
                margin-top: 12*@vm_base;
              }
              // line-height: 1;
              // display: flex;
              // justify-content: center;
              // align-items: center;
              // border: 1px solid red;
              // img{
              //   width: 32*@vm_base;
              //   height: 32*@vm_base;
              //   // margin-left: 10*@vm_base;
              // }
            }
          }
          .fl23_unviper_enterblock_right{
            width: 200*@vm_base;
            height: 250*@vm_base;
            background-image: url(../../assets/images/fl20210204/fl23_yoga.png);
            background-position: center;
            background-size: auto 100%;
            background-repeat: no-repeat;
            float: right;
            border-radius: 4*@vm_base;
            position: relative;
            .fl23_unviper_enterblock_right_ma{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              width: 100%;
              height: 250*@vm_base;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
              border-radius: 4*@vm_base;
              opacity: 0.5;
            }
            .fl23_unviper_enterblock_right_co{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 2;
              margin-bottom: 15*@vm_base;
              margin-left: 30*@vm_base;
              font-size: 30*@vm_base;
              font-weight: 600;
              color: #FFFFFF;
              // line-height: 1;
              // display: flex;
              // justify-content: center;
              // align-items: center;
              div{
                width: 136*@vm_base;
                text-align: center;
                border: 2*@vm_base solid;
                border-image: linear-gradient(225deg, rgba(242, 206, 136, 1), rgba(206, 167, 119, 1)) 2 2;
                font-size: 20*@vm_base;
                font-weight: 500;
                color: #F2CE88;
                padding: 8*@vm_base;
                margin-top: 12*@vm_base;
              }
              // img{
              //   width: 32*@vm_base;
              //   height: 32*@vm_base;
              //   margin-left: 10*@vm_base;
              // }
            }
          }
        }
      }
    }
    .fl23_unviper_activity{
      width: 100%;
      margin-top: 60*@vm_base;
      img{
        width: 50%;
        float: left;
      }
    }
    .fl23_unviper_banner{
      width: 100%;
      margin-top: 60*@vm_base;
      .vindex_banner_item{
        width: 100%;
        position: relative;
        .item{
          width: 100%;
          height: 500*@vm_base;
          background-size: auto 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
        .vindex_banner_item_indicators{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          margin-bottom: 20*@vm_base;
          z-index: 3;
          text-align: center;
          .indicators_block{
            display: inline-block;
            width:10*@vm_base;
            height:4*@vm_base;
            background:rgba(255,255,255,1);
            // border-radius:5*@vm_base;
            opacity:0.39;
            margin: 0 5*@vm_base;
          }
          .indicators_block_current{
            width:30*@vm_base;
            background:rgba(255,255,255,1);
            opacity:1;
            // border-radius:4*@vm_base;
          }
        }
      }
    }
  }
  .fl23_viper{
    width: 100%;
    .fl23_unviper_banner{
      width: 100%;
      .vindex_banner_item{
        position: relative;
        width: 100%;
        .item{
          width: 100%;
          height: 560*@vm_base;
          background-size: auto 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
        .vindex_banner_item_indicators{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          margin-bottom: 20*@vm_base;
          z-index: 3;
          text-align: center;
          .indicators_block{
            display: inline-block;
            width:10*@vm_base;
            height:4*@vm_base;
            background:rgba(255,255,255,1);
            // border-radius:5*@vm_base;
            opacity:0.39;
            margin: 0 5*@vm_base;
          }
          .indicators_block_current{
            width:30*@vm_base;
            background:rgba(255,255,255,1);
            opacity:1;
            // border-radius:4*@vm_base;
          }
        }
      }
    }
    .fl23_unviper_enter{
      width: 100%;
      padding: 0 40*@vm_base;
      height: 454*@vm_base;
      margin-top: 60*@vm_base;
      .fl23_unviper_enteritem{
        width: 100%;
        height: 380*@vm_base;
        background: #FFFFFF;
        border-radius: 4*@vm_base;
        box-shadow: 0 6*@vm_base 10*@vm_base 0 rgba(0, 0, 0, 0.2);
        .fl23_unviper_enteritem_title{
          width: 100%;
          font-size: 40*@vm_base;
          font-weight: 700;
          color: #333333;
          padding: 60*@vm_base 40*@vm_base 0 40*@vm_base;
        }
        .fl23_unviper_enteritem_stitle{
          width: 100%;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: #888888;
          padding: 20*@vm_base 40*@vm_base 40*@vm_base 40*@vm_base;
        }
        .fl23_unviper_enterblock{
          padding: 0 40*@vm_base;
          width: 100%;
          .fl23_unviper_enterblock_left{
            width: 370*@vm_base;
            height: 250*@vm_base;
            background-image: url(../../assets/images/fl20210204/fl23_swim.png);
            background-position: center;
            background-size: auto 100%;
            background-repeat: no-repeat;
            float: left;
            border-radius: 4*@vm_base;
            position: relative;
            .fl23_unviper_enterblock_left_ma{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              width: 100%;
              height: 250*@vm_base;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
              border-radius: 4*@vm_base;
              opacity: 0.5;
            }
            .fl23_unviper_enterblock_left_co{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 2;
              margin-bottom: 15*@vm_base;
              margin-left: 30*@vm_base;
              font-size: 30*@vm_base;
              font-weight: 600;
              color: #FFFFFF;
              div{
                width: 136*@vm_base;
                text-align: center;
                border: 2*@vm_base solid;
                border-image: linear-gradient(225deg, rgba(242, 206, 136, 1), rgba(206, 167, 119, 1)) 2 2;
                font-size: 20*@vm_base;
                font-weight: 500;
                color: #F2CE88;
                padding: 8*@vm_base;
                margin-top: 12*@vm_base;
              }
              // // line-height: 1;
              // // border: 1px solid red;
              // display: flex;
              // justify-content: center;
              // align-items: center;
              // img{
              //   width: 32*@vm_base;
              //   height: 32*@vm_base;
              //   margin-left: 10*@vm_base;
              // }
            }
          }
          .fl23_unviper_enterblock_right{
            width: 200*@vm_base;
            height: 250*@vm_base;
            background-image: url(../../assets/images/fl20210204/fl23_yoga.png);
            background-position: center;
            background-size: auto 100%;
            background-repeat: no-repeat;
            float: right;
            border-radius: 4*@vm_base;
            position: relative;
            .fl23_unviper_enterblock_right_ma{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 1;
              width: 100%;
              height: 250*@vm_base;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
              border-radius: 4*@vm_base;
              opacity: 0.5;
            }
            .fl23_unviper_enterblock_right_co{
              position: absolute;
              bottom: 0;
              left: 0;
              z-index: 2;
              margin-bottom: 15*@vm_base;
              margin-left: 30*@vm_base;
              font-size: 30*@vm_base;
              font-weight: 600;
              color: #FFFFFF;
              div{
                width: 136*@vm_base;
                text-align: center;
                border: 2*@vm_base solid;
                border-image: linear-gradient(225deg, rgba(242, 206, 136, 1), rgba(206, 167, 119, 1)) 2 2;
                font-size: 20*@vm_base;
                font-weight: 500;
                color: #F2CE88;
                padding: 8*@vm_base;
                margin-top: 12*@vm_base;
              }
              // // line-height: 1;
              // display: flex;
              // justify-content: center;
              // align-items: center;
              // img{
              //   width: 32*@vm_base;
              //   height: 32*@vm_base;
              //   margin-left: 10*@vm_base;
              // }
            }
          }
        }
      }
    }
    .fl23_unviper_activity{
      width: 100%;
      padding: 0 40*@vm_base;
      margin-top: 60*@vm_base;
      img{
        width: 50%;
        float: left;
      }
    }
  }
  .fl23_list{
    width: 100%;
    padding: 80*@vm_base 40*@vm_base 20*@vm_base 40*@vm_base;
    // position: relative;
    // border: 1px solid red;
    .fl23_list_title{
      width: 100%;
      font-size: 40*@vm_base;
      font-weight: 700;
      color: #000000;
      padding-bottom: 10*@vm_base;
      .fl23_list_title_hotol{
        width: 78.5%;
        margin-left: 10.75%;
      }
      .fl23_list_title_brand{
        width: 64%;
        margin-left: 18%;
      }
    }
    .fl23_list_item{
      width: 100%;
      height: 418*@vm_base;
      background-position: center;
      background-repeat: no-repeat;
      background-size: auto 100%;
      margin-top: 40*@vm_base;
      border-radius: 4*@vm_base;
    }
    .fl23_list_item_re{
      position: relative;
      .fl23_list_item_re_img{
        position: absolute;
        top: 0;
        left: 0;
        margin-top: -8*@vm_base;
        width: 160*@vm_base;
        height: 70*@vm_base;
        // padding: 18*@vm_base 52*@vm_base 19*@vm_base 23*@vm_base;
        background-image: url('../../assets/images/FLVersion/fl_index_icon.png');
        background-size: cover;

        font-size: 24*@vm_base;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 1*@vm_base;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .fl23_brand_item{
      width: 100%;
      height: 280*@vm_base;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% auto;
      margin-top: 40*@vm_base;
      border-radius: 4*@vm_base;
    }

  }
  .fl23_list_login{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    // border: 1px solid red;
    padding: 0 40*@vm_base 0*@vm_base 40*@vm_base;
    margin-bottom: 98*@vm_base;


    .fl23_list_logindiv{
      width: 100%;
      background: rgba(0, 0, 0, 0.8);
      border-radius: 4*@vm_base;
      padding: 12*@vm_base 40*@vm_base 12*@vm_base 24*@vm_base;
      position: relative;
      .fl23_list_logindiv_icon{
        width: 80*@vm_base;
        float: left;
      }
      .fl23_list_logindiv_txt{
        font-size: 24*@vm_base;
        font-weight: 400;
        color: #F5E6CB;
        float: left;
        padding: 8*@vm_base 0 0 22*@vm_base;
      }
      .fl23_list_logindiv_btn{
        background: linear-gradient(135deg, #0A0A0A 0%, #4B3D31 100%);
        border-radius: 4*@vm_base;
        padding: 12*@vm_base 22*@vm_base;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #F2CE88;
        float: right;
        margin-top: 12*@vm_base;
      }
      .fl23_list_logindiv_close{
        position: absolute;
        top: 0;
        right: 0;
        width: 40*@vm_base;
        height: 40*@vm_base;
        // border: 1px solid red;
        background-image: url('../../assets/images/base/video_close_white.png');
        background-size: 20*@vm_base 20*@vm_base;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
  }
  .fl23_list_loginH{
    // border: 1px solid blue;
    margin-bottom: 132*@vm_base;
  }

  .vip_customac{
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 99;
    margin-bottom: 200*@vm_base;
    font-size: 22*@vm_base;
    font-weight: 400;
    color: #E1C786;
    background: #000000;
    box-shadow: 0 0 10*@vm_base 0 rgba(255, 255, 255, 0.1);
    border-radius: 48*@vm_base 0 0 48*@vm_base;
    padding: 20*@vm_base 12*@vm_base 20*@vm_base 72*@vm_base;
    background-image: url(../../assets/images/fl20210204/customerservice_online.png);
    background-size: 36*@vm_base;
    background-position: 24*@vm_base center;
    background-repeat: no-repeat;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue